import { pxToRem } from './utils'

export const color = {
  'aero100': '#f0f8ff',
  'aero200': '#dceefe',
  'aero300': '#bbdbf7',
  'aero400': '#85b3db',
  'aero500': '#6286b7',
  'aero600': '#2e628e',
  'aero700': '#1a3656',
  'aero800': '#132a44',
  'aero800-70': 'rgba(19, 42, 68, 0.7)',
  'aero850': '#0d2035',
  'aero875': '#0c1c2f',
  'aero900': '#09182a',
  'aero950': '#081525',
  'aero975': '#071321',
  'aero1000': '#06111d',
  'autumn50': '#f9f3e9',
  'autumn100': '#ebd9ba',
  'autumn200': '#e2c799',
  'autumn300': '#d5ad6a',
  'autumn400': '#cd9d4d',
  'autumn500': '#c08521',
  'autumn600': '#af791e',
  'autumn700': '#885e17',
  'autumn800': '#6a4912',
  'autumn900': '#51380e',
  'aqua50': '#e9f9f7',
  'aqua100': '#baeee7',
  'aqua200': '#98e5dc',
  'aqua300': '#69d9cc',
  'aqua400': '#4cd2c2',
  'aqua500': '#1fc7b3',
  'aqua600': '#1cb5a3',
  'aqua700': '#168d7f',
  'aqua800': '#116d62',
  'aqua900': '#0d544b',
  'blue50': '#e6f2fe',
  'blue100': '#b0d6fa',
  'blue200': '#8ac3f8',
  'blue300': '#54a7f5',
  'blue400': '#3396f3',
  'blue500': '#007cf0',
  'blue600': '#0071da',
  'blue700': '#0058aa',
  'blue800': '#004484',
  'blue900': '#003465',
  'blush50': '#fff7f5',
  'blush100': '#ffe6e1',
  'blush200': '#ffd9d2',
  'blush300': '#ffc8be',
  'blush400': '#ffbdb1',
  'blush500': '#ffad9e',
  'blush600': '#e89d90',
  'blush700': '#b57b70',
  'blush800': '#8c5f57',
  'blush900': '#6b4942',
  'candy50': '#fff1f3',
  'candy100': '#ffd4db',
  'candy200': '#ffc0c9',
  'candy300': '#ffa3b1',
  'candy400': '#ff91a1',
  'candy500': '#ff758a',
  'candy600': '#e86a7e',
  'candy700': '#b55362',
  'candy800': '#8c404c',
  'candy900': '#6b313a',
  'crimson50': '#f3ecec',
  'crimson100': '#d9c3c3',
  'crimson200': '#c7a6a6',
  'crimson300': '#ad7d7d',
  'crimson400': '#9d6464',
  'crimson500': '#853d3d',
  'crimson600': '#793838',
  'crimson700': '#5e2b2b',
  'crimson800': '#492222',
  'crimson900': '#381a1a',
  'forest50': '#ebf1ed',
  'forest100': '#c0d4c6',
  'forest200': '#a2bfab',
  'forest300': '#78a184',
  'forest400': '#5d8f6d',
  'forest500': '#357348',
  'forest600': '#306942',
  'forest700': '#265233',
  'forest800': '#1d3f28',
  'forest900': '#16301e',
  'green50': '#edfdf0',
  'green100': '#c8f7d0',
  'green200': '#adf4b9',
  'green300': '#87ee98',
  'green400': '#70eb85',
  'green500': '#4ce666',
  'green600': '#45d15d',
  'green700': '#36a348',
  'green800': '#2a7f38',
  'green900': '#20612b',
  'grey50': '#ececec',
  'grey100': '#c3c3c3',
  'grey200': '#a6a6a6',
  'grey300': '#7d7d7d',
  'grey400': '#646464',
  'grey500': '#3d3d3d',
  'grey600': '#383838',
  'grey700': '#2b2b2b',
  'grey800': '#222222',
  'grey900': '#1a1a1a',
  'lavender50': '#fbf6fc',
  'lavender100': '#f2e3f4',
  'lavender200': '#ebd6ef',
  'lavender300': '#e2c3e8',
  'lavender400': '#ddb8e4',
  'lavender500': '#d4a6dd',
  'lavender600': '#c197c9',
  'lavender700': '#97769d',
  'lavender800': '#755b7a',
  'lavender900': '#59465d',
  'lemon50': '#fefff3',
  'lemon100': '#fdffd9',
  'lemon200': '#fbffc7',
  'lemon300': '#faffad',
  'lemon400': '#f9ff9d',
  'lemon500': '#f7ff85',
  'lemon600': '#e1e879',
  'lemon700': '#afb55e',
  'lemon800': '#888c49',
  'lemon900': '#686b38',
  'lime50': '#f2f9ec',
  'lime100': '#d8ecc3',
  'lime200': '#c5e3a5',
  'lime300': '#aad77c',
  'lime400': '#99cf63',
  'lime500': '#80c33c',
  'lime600': '#74b137',
  'lime700': '#5b8a2b',
  'lime800': '#466b21',
  'lime900': '#365219',
  'mint50': '#f3fbf6',
  'mint100': '#dbf2e2',
  'mint200': '#c9ecd4',
  'mint300': '#b1e4c0',
  'mint400': '#a1deb4',
  'mint500': '#8ad6a1',
  'mint600': '#7ec393',
  'mint700': '#629872',
  'mint800': '#4c7659',
  'mint900': '#3a5a44',
  'navy50': '#eaf0f7',
  'navy100': '#bdd1e7',
  'navy200': '#9dbbdc',
  'navy300': '#709ccc',
  'navy400': '#5489c2',
  'navy500': '#296bb3',
  'navy600': '#2561a3',
  'navy700': '#1d4c7f',
  'navy800': '#173b62',
  'navy900': '#112d4b',
  'neutral00': '#ffffff',
  'neutral50': '#f8f8f8',
  'neutral75': '#e3e3e3',
  'neutral75-70': 'rgba(227, 227, 227, 0.7)',
  'neutral200': '#cacfd3',
  'neutral250': '#d7d7d7',
  'neutral300': '#a8afb7',
  'neutral400': '#68738d',
  'neutral450': '#5d677e',
  'ocean50': '#e6e8f4',
  'ocean100': '#b0b9dc',
  'ocean200': '#8a97cb',
  'ocean300': '#5468b4',
  'ocean400': '#334aa5',
  'ocean500': '#001d8f',
  'ocean600': '#001a82',
  'ocean700': '#001566',
  'ocean800': '#00104f',
  'ocean900': '#000c3c',
  'orange50': '#fdf4ed',
  'orange100': '#f7ddc8',
  'orange200': '#f4ccad',
  'orange300': '#eeb587',
  'orange400': '#eba770',
  'orange500': '#e6914c',
  'orange600': '#d18445',
  'orange700': '#a36736',
  'orange800': '#7f502a',
  'orange900': '#613d20',
  'pink50': '#fdedf3',
  'pink100': '#f7c8d8',
  'pink200': '#f4adc6',
  'pink300': '#ee87ab',
  'pink400': '#eb709b',
  'pink500': '#e64c82',
  'pink600': '#d14576',
  'pink700': '#a3365c',
  'pink800': '#7f2a48',
  'pink900': '#612037',
  'purple50': '#f0e7fd',
  'purple100': '#d0b5f8',
  'purple200': '#b992f4',
  'purple300': '#9960f0',
  'purple400': '#8541ed',
  'purple500': '#6711e8',
  'purple600': '#5e0fd3',
  'purple700': '#490ca5',
  'purple800': '#390980',
  'purple900': '#2b0761',
  'red50': '#fdeded',
  'red100': '#f7c8c8',
  'red200': '#f4adad',
  'red300': '#ee8787',
  'red400': '#eb7070',
  'red500': '#e64c4c',
  'red600': '#d14545',
  'red700': '#a33636',
  'red800': '#7f2a2a',
  'red900': '#612020',
  'sand50': '#fcf9f6',
  'sand100': '#f4ece3',
  'sand200': '#efe2d6',
  'sand300': '#e8d5c3',
  'sand400': '#e4cdb8',
  'sand500': '#ddc1a6',
  'sand600': '#c9b097',
  'sand700': '#9d8976',
  'sand800': '#7a6a5b',
  'sand900': '#5d5146',
  'sky50': '#f5fafc',
  'sky100': '#e1f0f6',
  'sky200': '#d2e9f1',
  'sky300': '#bde0eb',
  'sky400': '#b1d9e7',
  'sky500': '#9dd0e1',
  'sky600': '#8fbdcd',
  'sky700': '#6f94a0',
  'sky800': '#56727c',
  'sky900': '#42575f',
  'slate50': '#eef0f3',
  'slate100': '#cad1da',
  'slate200': '#8c9baf',
  'slate300': '#8c9baf',
  'slate400': '#7588a0',
  'slate500': '#536a88',
  'slate600': '#4c607c',
  'slate700': '#3b4b61',
  'slate800': '#2e3a4b',
  'slate900': '#232d39',
  'violet50': '#edebf0',
  'violet100': '#c6c0d0',
  'violet200': '#aba1b9',
  'violet300': '#847698',
  'violet400': '#6d5c85',
  'violet500': '#483366',
  'violet600': '#422e5d',
  'violet700': '#332448',
  'violet800': '#281c38',
  'violet900': '#1e152b',
  'white00': '#ffffff',
  'white50': '#fafafa',
  'white100': '#f1f1f1',
  'white200': '#eaeaea',
  'white300': '#e0e0e0',
  'white400': '#dadada',
  'white500': '#d1d1d1',
  'white600': '#bebebe',
  'white700': '#949494',
  'white800': '#737373',
  'white900': '#585858',
  'yellow50': '#fdf8ed',
  'yellow100': '#f7ebc8',
  'yellow200': '#f4e1ad',
  'yellow300': '#eed387',
  'yellow400': '#ebca70',
  'yellow500': '#e6bd4c',
  'yellow600': '#d1ac45',
  'yellow700': '#a38636',
  'opacityWhite00': '#ffffff',
  'yellow800': '#7f682a',
  'yellow900': '#614f20',
  'opacityWhite01': 'rgba(255, 255, 255, 0.01)',
  'opacityWhite02': 'rgba(255, 255, 255, 0.02)',
  'opacityWhite03': 'rgba(255, 255, 255, 0.03)',
  'opacityWhite04': 'rgba(255, 255, 255, 0.04)',
  'opacityWhite05': 'rgba(255, 255, 255, 0.05)',
  'opacityWhite10': 'rgba(255, 255, 255, 0.1)',
  'opacityWhite15': 'rgba(255, 255, 255, 0.15)',
  'opacityWhite20': 'rgba(255, 255, 255, 0.2)',
  'opacityWhite30': 'rgba(255, 255, 255, 0.3)',
  'opacityWhite40': 'rgba(255, 255, 255, 0.4)',
  'opacityWhite50': 'rgba(255, 255, 255, 0.5)',
  'opacityWhite60': 'rgba(255, 255, 255, 0.6)',
  'opacityWhite70': 'rgba(255, 255, 255, 0.7)',
  'opacityWhite80': 'rgba(255, 255, 255, 0.8)',
  'opacityWhite90': 'rgba(255, 255, 255, 0.9)',
  'opacityBlack00': '#000000',
  'opacityBlack01': 'rgba(0, 0, 0, 0.01)',
  'opacityBlack02': 'rgba(0, 0, 0, 0.02)',
  'opacityBlack03': 'rgba(0, 0, 0, 0.03)',
  'opacityBlack04': 'rgba(0, 0, 0, 0.04)',
  'opacityBlack05': 'rgba(0, 0, 0, 0.05)',
  'opacityBlack10': 'rgba(0, 0, 0, 0.1)',
  'opacityBlack15': 'rgba(0, 0, 0, 0.15)',
  'opacityBlack20': 'rgba(0, 0, 0, 0.2)',
  'opacityBlack30': 'rgba(0, 0, 0, 0.3)',
  'opacityBlack40': 'rgba(0, 0, 0, 0.4)',
  'opacityBlack50': 'rgba(0, 0, 0, 0.5)',
  'opacityBlack60': 'rgba(0, 0, 0, 0.6)',
  'opacityBlack70': 'rgba(0, 0, 0, 0.7)',
  'opacityBlack80': 'rgba(0, 0, 0, 0.8)',
  'opacityBlack90': 'rgba(0, 0, 0, 0.9)',
  'chainsEthereum': '#ffffff',
  'chainsEthereumBackground': '#396993',
  'chainsBinance': '#ffffff',
  'chainsBinanceBackground': '#ebbb00',
  'chainsPolygon': '#ffffff',
  'chainsPolygonBackground': '#9b22ff',
  'chainsArbitrum': '#ffffff',
  'chainsArbitrumBackground': '#003470',
  'chainsAvalanche': '#ffffff',
  'chainsAvalancheBackground': '#de0000',
  'chainsFantom': '#ffffff',
  'chainsFantomBackground': '#0f7fff',
  'chainsCronos': '#ffffff',
  'chainsCronosBackground': '#041836',
  'chainsRoni': '#ffffff',
  'chainsRoniBackground': '#019ec9',
  'chainsOptimism': '#ffffff',
  'chainsOptimismBackground': '#e95557',
  'chainsPalm': '#ffffff',
  'chainsPalmBackground': '#6818aa',
  'chainsAptos': '#ffffff',
  'chainsAptosBackground': '#041836',
  'chainsPulse': '#ffffff',
  'chainsPulseBackground': '#a60af6',
  'chainsHarmony': '#ffffff',
  'chainsHarmonyBackground': '#21c6dc',
  'chainsSolana': '#ffffff',
  'chainsSolanaBackground': '#9d9d9d',
  'opacityGreen10': 'rgba(42, 127, 56, 0.1)',
  'opacityGreen20': 'rgba(42, 127, 56, 0.2)',
  'opacityGreen30': 'rgba(42, 127, 56, 0.3)',
  'opacityGreen40': 'rgba(42, 127, 56, 0.4)',
  'opacityRed10': 'rgba(209, 69, 69, 0.1)',
  'opacityRed20': 'rgba(209, 69, 69, 0.2)',
  'opacityRed30': 'rgba(209, 69, 69, 0.3)',
  'opacityRed40': 'rgba(209, 69, 69, 0.4)',
  'opacityBlue30': 'rgba(0, 124, 240, 0.3)',
  'opacityBlue40': 'rgba(0, 124, 240, 0.4)',
  'opacityNavy30': 'rgba(29, 76, 127, 0.3)',
  'opacityNavy40': 'rgba(29, 76, 127, 0.4)',
  'opacityYellow30': 'rgba(209, 172, 69, 0.3)',
  'opacityYellow40': 'rgba(209, 172, 69, 0.4)',
  'opacityPurple30': 'rgba(133, 65, 237, 0.3)',
  'opacityPurple40': 'rgba(133, 65, 237, 0.4)',
  'opacityPink30': 'rgba(235, 112, 155, 0.3)',
  'opacityPink40': 'rgba(235, 112, 155, 0.4)',
  'opacitySlate30': 'rgba(117, 136, 160, 0.3)',
  'opacitySlate40': 'rgba(117, 136, 160, 0.4)',
  'opacityAero30': 'rgba(133, 179, 219, 0.3)',
  'opacityAero40': 'rgba(133, 179, 219, 0.4)',
}

export const size = {
  2: pxToRem(2),
  4: pxToRem(4),
  6: pxToRem(6),
  8: pxToRem(8),
  10: pxToRem(10),
  12: pxToRem(12),
  14: pxToRem(14),
  16: pxToRem(16),
  18: pxToRem(18),
  20: pxToRem(20),
  22: pxToRem(22),
  24: pxToRem(24),
  28: pxToRem(28),
  32: pxToRem(32),
  36: pxToRem(36),
  40: pxToRem(40),
  44: pxToRem(44),
  48: pxToRem(48),
  52: pxToRem(52),
  56: pxToRem(56),
  60: pxToRem(60),
  64: pxToRem(64),
  68: pxToRem(68),
  72: pxToRem(72),
  76: pxToRem(76),
  80: pxToRem(80),
  84: pxToRem(84),
  88: pxToRem(88),
  92: pxToRem(92),
  96: pxToRem(96),
  100: pxToRem(100),
  104: pxToRem(104),
  116: pxToRem(116),
  124: pxToRem(124),
  132: pxToRem(132),
  140: pxToRem(140),
  148: pxToRem(148),
  156: pxToRem(156),
  164: pxToRem(164),
  172: pxToRem(172),
  180: pxToRem(180),
  188: pxToRem(188),
  196: pxToRem(196),
}
